export const MAX_ADULT_GUESTS = 3;
export const MAX_CHILDREN_GUESTS = 2;
